import { render } from "./ControlAccesoPlanes.vue?vue&type=template&id=80d54e08&scoped=true"
import script from "./ControlAccesoPlanes.vue?vue&type=script&lang=js"
export * from "./ControlAccesoPlanes.vue?vue&type=script&lang=js"

import "./ControlAccesoPlanes.vue?vue&type=style&index=0&id=80d54e08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d54e08"]])

export default __exports__